export default Object.freeze({
    LIFE_TOAST: 3000,
    ADMIN: 'מנהל',
    SUBMIT_COLEL_SETTINGS: 'submit-colel-settings',
    SUGGESTION_TYPE_EDIT: 1,
    SUGGESTION_TYPE_DELETE: 2,
    SUGGESTION_TYPE_ADD: 3,
    COLEL_TYPE: 1,
    PERSON_TYPE: 2
})